<template>
  <div class="address">
    <!-- 新增/编辑 地址 -->
    <el-dialog
      append-to-body
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      class="add-dialog"
      width="820px"
      :show-close="false"
    >
      <div slot="title" class="e-title">
        <span class="title-name">{{
          dialogType == 'add' ? '添加新地址' : '编辑地址'
        }}</span>
        <span class="icon" @click="dialogFormVisible = false"
          ><i class="el-icon-close"></i
        ></span>
      </div>
      <el-form
        ref="submitFormRef"
        :model="submitFrom"
        :rules="rules"
        label-width="140px"
        class="margin-t10"
      >
        <el-row :gutter="19" style="margin-left: 0;margin-right: 0">
          <el-col v-if="dialogType == 'add'" :span="22">
            <el-form-item
              label="地址类型:"
              prop="checkedAddr"
              class="chioce-addr"
            >
              <el-checkbox-group
                v-model="submitFrom.checkedAddr"
                @change="handleCheckedAddr"
              >
                <el-checkbox label="2" :disabled="noCheck == 2"
                  >收货地址</el-checkbox
                >
                <!-- <el-checkbox label="1" :disabled="noCheck == 1"
                  >收发票地址</el-checkbox
                > -->
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col v-show="isLimit" :span="22">
            <el-form-item prop="isShare" class="chioce-addr">
              <span slot="label">
                <span>是否公用</span>
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  content="公用地址公司内所有人均可见、可用。私用地址仅创建者可见、可用。仅管理员可创建公用地址。"
                >
                  <i slot="reference" class="header-icon el-icon-info"></i>
                </el-popover>
              </span>

              <el-radio-group v-model="submitFrom.isShare">
                <el-radio label="2">公用</el-radio>
                <el-radio label="1">私用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="收件人:" prop="realName">
              <el-input
                v-model="submitFrom.realName"
                :disabled="submitFrom.isShare === '2' && !isLimit"
                autocomplete="off"
                placeholder="请输入收件人姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="手机号:" prop="mobile">
              <el-input
                v-model="submitFrom.mobile"
                :disabled="submitFrom.isShare === '2' && !isLimit"
                autocomplete="off"
                placeholder="请输入收件人手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22" class="address-wrap">
            <!-- <span class="red-flag">*</span> -->
            <el-form-item label="地址:" prop="county">
              <div class="area-out">
                <el-form-item
                  style="display: inline-block; width: 200px"
                  prop="province"
                >
                  <el-select
                    v-model="submitFrom.province"
                    :disabled="submitFrom.isShare === '2' && !isLimit"
                    placeholder="请选择省份"
                    @change="getCityByAreaId()"
                  >
                    <el-option
                      v-for="provinceItem in provinceArr"
                      :key="provinceItem.dataId"
                      :label="provinceItem.areaName"
                      :value="provinceItem.dataId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  style="display: inline-block; width: 200px"
                  prop="city"
                >
                  <el-select
                    v-model="submitFrom.city"
                    :disabled="submitFrom.isShare === '2' && !isLimit"
                    placeholder="请选择城市"
                    @change="getDistrictByCityId()"
                  >
                    <el-option
                      v-for="cityItem in cityArr"
                      :key="cityItem.dataId"
                      :label="cityItem.areaName"
                      :value="cityItem.dataId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  style="display: inline-block; width: 200px"
                  prop="county"
                >
                  <el-select
                    v-model="submitFrom.county"
                    :disabled="submitFrom.isShare === '2' && !isLimit"
                    placeholder="区/县/街道"
                  >
                    <el-option
                      v-for="countyItem in districtArr"
                      :key="countyItem.dataId"
                      :label="countyItem.areaName"
                      :value="countyItem.dataId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="详细地址:" prop="address">
              <el-input
                v-model="submitFrom.address"
                :disabled="submitFrom.isShare === '2' && !isLimit"
                type="textarea"
                placeholder="请填写详细地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item
              label="邮政编码:"
              prop="postCode"
              placeholder="请输入邮政编码"
            >
              <el-input
                v-model="submitFrom.postCode"
                :disabled="submitFrom.isShare === '2' && !isLimit"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item
              label="电子邮箱:"
              prop="email"
              placeholder="请输入电子邮箱"
            >
              <el-input
                v-model="submitFrom.email"
                :disabled="submitFrom.isShare === '2' && !isLimit"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="" class="set-default">
              <el-checkbox v-model="submitFrom.isdefault">设为默认</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <eui-btn type="secondary" @click="toBack('submitFormRef')">
          返回
        </eui-btn>
        <eui-btn type="primary" @click="submitForm">确定</eui-btn>
      </div>
    </el-dialog>

    <!-- 管理地址 -->
    <el-dialog
      :visible.sync="showMask"
      width="800"
      height="600"
      :show-close="false"
      append-to-body
      :close-on-click-modal="false"
    >
      <div slot="title" class="e-title">
        <span class="title-name">管理地址</span>
        <span class="icon" @click="closeAddressDialog"
          ><i class="el-icon-close"></i
        ></span>
      </div>
      <div class="e-content margin-b20">
        <el-table
          :data="addressList"
          style="width: 100%"
          height="361"
          :show-header="false"
          :cell-class-name="rowClass"
          :border="false"
        >
          <el-table-column label="" width="50">
            <template slot-scope="scope">
              <div style="margin-left: 10px">
                <el-radio
                  v-model="addressId"
                  :label="scope.row.addressId"
                  @change.native="choosenItem(scope.row)"
                ></el-radio>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="180">
            <template slot-scope="scope">
              <div class="address-detail">
                <span>
                  {{
                    `${scope.row.provinceName} ${scope.row.cityName} ${scope.row.regionName} ${scope.row.address}`
                  }}
                </span>
              </div>
              <div>
                {{ `${scope.row.realName} ${scope.row.mobile}` }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100">
            <template slot-scope="scope">
              <div style="text-align: center">

                <eui-btn  type="text" size="12" @click="rowEditHandle(scope.row, '2')">编辑</eui-btn>
                <eui-btn type="text" size="12" style="color: #EF4C56" @click="deleteOrderAddress(scope.row, 'single', '2')">删除</eui-btn>

<!--                <span class="table-edit" @click="rowEditHandle(scope.row, '2')">编辑</span>-->
<!--                <span class="table-del" @click="deleteOrderAddress(scope.row, 'single', '2')">删除</span>-->

              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="dialog-center">
        <!-- <e-pager
          style="margin-top: 20px"
          :page-index="queryParams.pageNum"
          :total="queryParams.pageToal"
          :page-size="queryParams.pageSize"
          @change="handleCurrentChange"
        ></e-pager> -->
        <!-- @size-change="handleSizeChange" -->
        <div class="flex-r">
          <el-pagination
                  :pager-count="5"
                  layout="total, prev, pager, next"
                  :current-page="queryParams.pageNum"
                  :total="queryParams.pageToal"
                  :page-size.sync="queryParams.pageSize"
                  @current-change="handleCurrentChange"
          ></el-pagination>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <eui-btn type="secondary" @click="chooseThisAddress">
          选择此地址
        </eui-btn>
        <eui-btn type="primary" @click="addNewAddress('2')">
          添加新地址
        </eui-btn>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import ePager from "@/components/common/e-pager.vue";
import Api from '@/modules/projectA/api/enquiry/index';
import AddressApi from '@/modules/projectA/api/address/index';
import UsreApi from '@/modules/projectA/api/user/index';
import {
  mobile,
  email,
  postalCode,
} from '@/modules/projectA/utils/verification';
import EuiBtn from "epec-ui/src/package/eui-btn/index";

export default {
  components: {
    EuiBtn
    // ePager,
  },
  props: {
    showMask: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      editAddressInfo: {},
      chooseAddress: {},
      dialogType: '',
      title: '新增发票',
      addFlag: '',
      noCheck: '',

      submitFrom: {
        checkedAddr: [],
        realName: '',
        mobile: '',
        address: '',
        province: '',
        city: '',
        county: '', // 区县
        addrAll: '',
        postCode: '',
        email: '',
        isdefault: false,
        isShare: '1',
      },

      provinceArr: [],
      cityArr: [],
      districtArr: [],
      rules: {
        checkedAddr: [
          {
            required: true,
            message: '请至少选择一个地址类型',
            trigger: 'blur',
          },
        ],
        realName: [
          {
            required: true,
            message: '请输入收件人姓名',
            trigger: ['blur', 'change'],
          },
        ],
        mobile: [
          {
            required: true,
            validator: mobile,
            trigger: ['blur', 'change'],
          },
        ],
        address: [
          {
            required: true,
            message: '请填写详细地址',
            trigger: ['blur', 'change'],
          },
        ],
        province: [
          {
            required: true,
            message: '请填写省份',
            trigger: ['blur', 'change'],
          },
        ],
        city: [
          {
            required: true,
            message: '请填写城市',
            trigger: ['blur', 'change'],
          },
        ],
        county: [
          {
            required: true,
            message: '请填写区县',
            // validator: checkedAddr,
            trigger: ['blur', 'change'],
          },
        ],

        address: [
          {
            required: true,
            message: '请输入收件人详细地址',
            trigger: ['blur', 'change'],
          },
        ],
        postCode: [
          {
            required: true,
            validator: postalCode,
            trigger: ['blur', 'change'],
          },
        ],
        email: [
          {
            validator: (rule, value, callback) => {
              email(rule, value, callback, false, false);
            },
            trigger: ['blur', 'change'],
          },
        ],
      },
      queryParams: { pageNum: 1, pageSize: 10, pageToal: 0 },
      addressId: -1,
      defaultAddressId: '',
      addressList: [],
      activeAddress: {},
      userInfo: {},
      invoiceOrMemberType: '',
      isLimit: '1',
    };
  },
  watch: {
    addressVisible(oldVal) {
      oldVal && this.getAddressList();
    },
  },

  async mounted() {
    this.getAddressList();
    this.isLimit = await this.getUserLimit();
  },
  methods: {
    closeAddressDialog() {
      this.$emit('update:showMask', false);
    },
    toBack(param) {
      this.dialogFormVisible = false;
      param = 'submitFormRef';
      this.$refs[param].resetFields();
    },

    choosenItem(obj) {
      this.chooseAddress = obj;
      this.addressId = obj.addressId;
    },
    chooseThisAddress() {
      if (this.chooseAddress && this.chooseAddress.addressId) {
        this.activeAddress = this.chooseAddress;
        this.addressId = this.chooseAddress.addressId;
      }
      this.$emit('setAddress', this.activeAddress);
    },

    // 修改 收货地址
    rowEditHandle(dt, type) {
      this.editAddressInfo = dt;
      this.chooseAddress = dt;
      // this.addressId = dt.addressId;
      this.dialogType = 'edit';
      this.submitFrom = {
        checkedAddr: type,
        realName: dt.realName,
        mobile: dt.mobile,
        address: dt.address,
        addressid: dt.addressId,
        province: parseInt(dt.provinceId),
        city: parseInt(dt.cityId),
        county: parseInt(dt.regionId), // 区县
        addrAll: `${dt.provinceId},${dt.cityId},${dt.regionId}`,
        postCode: dt.postCode,
        email: dt.email || '',
        isdefault: dt.isDefault === 1,
        isShare: `${dt.isShare}`,
      };
      // console.log(this.submitFrom);
      this.getAreaByCountryCode();
      this.getCityByAreaId(dt.provinceId);
      this.getDistrictByCityId(dt.cityId);
      this.dialogFormVisible = true;
    },
    // 获取省份信息
    getAreaByCountryCode() {
      const para = {
        countryCode: 'CN',
      };
      Api.getAreaByCountryCode(para).then((res) => {
        if (res.status) {
          this.provinceArr = res.data;
        }
      });
    },
    // 获取城市信息
    getCityByAreaId(province = '') {
      this.submitFrom.city = province == '' ? '' : this.submitFrom.city;
      this.submitFrom.county = province == '' ? '' : this.submitFrom.county;
      const para = {
        areaId: province == '' ? this.submitFrom.province : province,
      };
      Api.getCityByAreaId(para).then((res) => {
        if (res.status) {
          this.cityArr = res.data;
        }
      });
    },
    // 获取区县信息
    getDistrictByCityId(city = '') {
      this.submitFrom.county = city == '' ? '' : this.submitFrom.county;
      const para = {
        cityId: city == '' ? this.submitFrom.city : city,
      };
      Api.getDistrictByCityId(para).then((res) => {
        if (res.status) {
          this.districtArr = res.data;
        }
      });
    },
    addNewAddress(data) {
      this.submitFrom.checkedAddr = [];
      this.submitFrom.checkedAddr.push(data);
      this.addFlag = this.submitFrom.checkedAddr[0];
      this.noCheck = this.addFlag;
      this.dialogType = 'add';
      this.dialogFormVisible = true;
      this.invoiceOrMemberType = data;
      this.resetForm('submitFormRef', 'clear');
      // this.getAreaByCountryCode();
      this.getAddressList();
    },
    resetFormData() {
      this.submitFrom = {
        checkedAddr: [],
        realName: '',
        mobile: '',
        address: '',
        province: '',
        city: '',
        county: '', // 区县
        addrAll: '',
        postCode: '',
        email: '',
        isdefault: false,
        addressid: '',
        isShare: '1',
      };
    },
    // 重置新增
    resetForm(formName = 'submitFormRef', type = 'reset') {
      formName = 'submitFormRef';
      if (type == 'clear') {
        this.getAreaByCountryCode();
        if (this.submitFrom.province !== '') {
          this.resetFormData();
          this.$refs[formName].resetFields();
        }
      } else {
        this.$refs[formName].resetFields();
        this.getAreaByCountryCode();
      }
    },
    deleteOrderAddress(dt, type, data) {
      this.$alert('确定删除该地址？', '提示', {
        confirmButtonText: '确定',
        callback: (action) => {
          if (action === 'confirm') {
            const para =
              type === 'single'
                ? [
                    {
                      addressId: dt.addressId.toString(), // 地址编号
                      invoiceOrMemberType: data, //	地址类型(1： 收票地址 2：收货地址)	是
                    },
                  ]
                : dt;
            AddressApi.addressApi_addressDelete(para).then((res) => {
              if (res.success) {
                this.getAddressList();
                this.$message({
                  type: 'success',
                  message: `删除成功`,
                });
              }
            });
          }
        },
      });
    },
    // 地址类型选择
    handleCheckedAddr() {
      if (this.submitFrom.checkedAddr.length === 2) {
        this.addFlag = 'addAll';
      } else {
        this.addFlag = this.submitFrom.checkedAddr[0];
      }
    },
    // 提交   handleType = ''  handleType   新增：add   修改：''
    submitForm() {
      const handleType = this.dialogType === 'add' ? 'add' : '';
      this.$refs.submitFormRef.validate((valid) => {
        if (valid) {
          this.$confirm(
            `确认${this.dialogType === 'add' ? '新增' : '修改'}该地址?`,
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }
          ).then(() => {
            const para = {
              // address: this.submitFrom.address, // 收件地址
              // postcode: this.submitFrom.postCode, // 邮政编码
              // mobile: this.submitFrom.mobile, // 手机号
              // isdefault: this.submitFrom.isdefault ? 1 : 0, // 是否设置默认地址
              // email: this.submitFrom.email, // 邮箱地址
              // realname: this.submitFrom.realName, // 收件人
              // // invoiceOrMemberType: this.invoiceOrMemberType, //	地址类型(1： 收发票地址 2：收货地址)	是	[string]
              // invoiceOrMemberType: this.submitFrom.checkedAddr.toString(), //	地址类型(1： 收发票地址 2：收货地址)	是	[string]
              // location: `${this.submitFrom.province},${this.submitFrom.city},${this.submitFrom.county}`, //	所在地区（取地区编号，用逗号分隔）
              // option: handleType, // 操作标识
              // addressid:
              //   this.submitFrom.addressid == undefined
              //     ? ''
              //     : this.submitFrom.addressid,

              address: this.submitFrom.address,
              addressId:
                this.submitFrom.addressid === undefined
                  ? ''
                  : this.submitFrom.addressid,
              email: this.submitFrom.email,
              invoiceOrMemberType: `${this.submitFrom.checkedAddr}`,
              isDefault: this.submitFrom.isdefault ? 1 : 0,
              isShare: this.submitFrom.isShare,
              location: `${this.submitFrom.province},${this.submitFrom.city},${this.submitFrom.county}`,
              mobile: this.submitFrom.mobile,
              option: handleType,
              postcode: this.submitFrom.postCode,
              realName: this.submitFrom.realName,
            };
            if (this.submitFrom.addressid === undefined) {
              this.OrderAddInfoHandle(para);
            } else {
              this.OrderaddressUpdata(para);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增、修改地址
    OrderAddInfoHandle(para) {
      AddressApi.addressApi_addressAdd(para).then((res) => {
        if (res.success) {
          Promise.all([this.getAddressList(), this.getInvoiceInfo()]).then(
            () => {
              this.addFlag = '';
              if (this.dialogType === 'add') {
                const param = 'submitFormRef';
                this.$refs[param].resetFields();
              }
              this.dialogType = '';
            }
          );
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.resetForm('submitFrom', 'clear');
        } else {
          this.$message({
            type: 'info',
            message: res.message,
          });
        }
      });

      this.dialogFormVisible = false;
      this.$parent.showMask = false;
    },

    OrderaddressUpdata(para) {
      AddressApi.addressApi_addressModify(para).then((res) => {
        if (res.success) {
          Promise.all([this.getAddressList(), this.getInvoiceInfo()]).then(
            () => {
              this.addFlag = '';
              if (this.dialogType === 'add') {
                const param = 'submitFormRef';
                this.$refs[param].resetFields();
              }
              this.dialogType = '';
            }
          );
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.resetForm('submitFrom', 'clear');
        } else {
          this.$message({
            type: 'info',
            message: res.message,
          });
        }
      });

      this.dialogFormVisible = false;
      this.$parent.showMask = false;
    },
    rowClass({ columnIndex }) {
      if (columnIndex === 2) {
        return 'cell-class';
      }
    },
    // 分页
    handleCurrentChange(num) {
      // 收货地址
      this.queryParams.pageNum = num;
      this.getAddressList();
    },
    // 获取收货地址列表
    async getAddressList() {
      const res = await AddressApi.addressApi_pageMemberAddress(
        this.queryParams
      );
      if (res.success) {
        const list = JSON.parse(JSON.stringify(res.data.records));
        const oldRecords = await this.formatMemberAddress(list);
        res.data.records = oldRecords;
        this.addressList = res.data.records;
        this.queryParams.pageToal = res.data.total;
        const rowObj = this.addressList.find((item) => {
          console.log(item.addressId, this.addressId);
          return item.addressId === this.addressId;
        });
        if (this.addressList.length === 1) {
          this.activeAddress = this.addressList[0];
          this.$emit('setAddress', this.activeAddress);
        }
        if (rowObj) {
          this.choosenItem(rowObj);
        }
        // 查看本地缓存是否有默认地址
        /* let store = localStorage.getItem("store");
        this.defaultAddressId = JSON.parse(store).addressId; */
        if (this.addressList.length > 0) {
          this.addressList.forEach((item) => {
            item.province = item.provinceName;
            item.city = item.cityName;
            item.region = item.regionName;
          });
          if (!this.activeAddress.realName && res.data.records[0]) {
            this.activeAddress = res.data.records[0];
          }
        } else {
          this.activeAddress = { realName: '', addressId: '' };
          this.addressId = -1;
          return;
        }
      }
      if (this.activeAddress) {
        this.addressId = this.activeAddress.addressId;
      }
      this.editAddressInfo = {};
    },

    // 修改收发货地址格式
    formatMemberAddress(list) {
      return new Promise((resolve) => {
        const oldRecords = [];
        list.map((item) => {
          const singleMap = {
            addressId: item.addressId,
            realName: item.realName,
            detailAddress: item.detailAddress,
            isDefault: item.isDefault,
            postCode: item.postcode,
            mobile: item.mobile,
            memberId: '',
            email: item.email,
            creatorId: '',
            creator: '',
            createTime: item.createTime,
            editTime: '',
            addressType: '',
            provinceId: item.provinceAreaId,
            provinceName: item.province,
            cityId: item.cityAreaId,
            cityName: item.city,
            regionId: item.countryAreaId,
            regionName: item.county,
            location: item.location,
            address: item.address,
            isShare: item.isShare,
          };
          oldRecords.push(singleMap);
          return '';
        });
        resolve(oldRecords);
      });
    },
    // 获得是否是管理员
    getUserLimit() {
      return new Promise((resolve) => {
        UsreApi.memberIsAdmin().then((info) => {
          if (info.success) {
            resolve(info.data);
          } else {
            this.$message.error('获得失败，请重试');
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
.el-tooltip__popper {
  max-width: 400px;
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
table td {
  border-right: none;
}
::v-deep .el-table__row .cell {
  font-size: 14px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2; /*要显示的行数*/
  -webkit-box-orient: vertical;
  color: #333;
  .el-radio__label {
    display: none;
  }
  .el-radio__inner {
    width: 18px;
    height: 18px;
  }
  .el-radio {
    margin-left: 10px;
  }
  .el-button {
    font-size: 12px;
  }
  .address-detail {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
::v-deep .el-table__row .cell-class {
  vertical-align: middle;
  .table-edit {
    color: #2587ff;
    cursor: pointer;
    margin-right: 12px;
    &:hover {
      text-decoration: underline;
    }
  }
  .table-del {
    color: #f0250f;
    cursor: pointer;
    margin-right: 7px;
    &:hover {
      text-decoration: underline;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 14px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2; /*要显示的行数*/
  -webkit-box-orient: vertical;
  color: #333;
  .el-radio__label {
    display: none;
  }
  .el-radio__inner {
    width: 18px;
    height: 18px;
  }
  .el-radio {
    margin-left: 10px;
  }
  .el-button {
    font-size: 12px;
  }
  .address-detail {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
::v-deep .el-table__row .cell-class {
  vertical-align: middle;
  .table-edit {
    color: #2587ff;
    cursor: pointer;
    margin-right: 12px;
    &:hover {
      text-decoration: underline;
    }
  }
  .table-del {
    color: #f0250f;
    cursor: pointer;
    margin-right: 7px;
    &:hover {
      text-decoration: underline;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 14px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2; /*要显示的行数*/
  -webkit-box-orient: vertical;
  color: #333;
  .el-radio__label {
    display: none;
  }
  .el-radio__inner {
    width: 18px;
    height: 18px;
  }
  .el-radio {
    margin-left: 10px;
  }
  .el-button {
    font-size: 12px;
  }
  .address-detail {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.address {
  display: flex;
  justify-content: space-between;
  ::v-deep .el-table__row td {
    vertical-align: top;
  }
  ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #bddbff;
    border-color: #bddbff;
    &::after {
      border-color: #fff;
    }
  }

  .add {
    color: #0263c9;
    border-bottom: 1px solid transparent;
    cursor: pointer;
    &:hover {
      border-bottom: 1px solid #0263c9;
    }
  }

  .default-text {
    border-radius: 4px;
    color: #fff;
    background: #2587ff;
    padding: 0 4px;
    font-size: 12px;
  }
  .add-dialog {
    margin-left: 0;
    ::v-deep .el-dialog__body {
      padding: 20px 60px 0 20px;
      .el-textarea__inner,
      .el-input__inner {
        height: 30px;
        line-height: 30px;
        border-radius: 0;
      }
      .el-form-item {
        margin-bottom: 20px;
      }
      .el-form-item__content {
        line-height: 1;
        margin-top: 4px;
      }
      .el-form-item__label {
        height: 30px;
        line-height: 30px;
      }
      .el-input__icon {
        height: 30px;
        line-height: 30px;
      }
    }
    .address-wrap {
      position: relative;
      .red-flag {
        position: absolute;
        left: 96px;
        top: 5px;
        color: #f56c6c;
      }
    }

    .dialog-footer {
      padding: 0;
      margin-top: 0;
      .e-btn {
        min-width: 80px;
        height: 30px;
        line-height: 28px;
        box-sizing: border-box;
        text-align: center;
      }
    }

    ::v-deep .el-dialog__footer {
      padding-top: 0;
    }
    .area-out {
      display: flex;
      justify-content: space-between;
      .el-form-item + .el-form-item {
        margin-left: 10px;
      }
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
  // ------

  .box {
    width: 394px;
    height: 154px;
    border: 1px solid #d9d9d9;
    .detail {
      @include flex(start, center, column);
      color: #333;
      font-size: 14px;
      line-height: 31px;
      margin: 5px 20px;

      .both-side {
        display: flex;
        justify-content: space-between;
        .receive-address {
          color: #2587ff;
          cursor: pointer;
          border-bottom: 1px solid transparent;
          &:hover {
            border-bottom: 1px solid #2587ff;
          }
        }
      }
      .margin-l8 {
        margin-left: -18px;
      }
      .no-right {
        margin: 12px 0 0;
      }
      .break {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }

  .no-info {
    display: flex;
    align-items: center;
    line-height: 74px;
    margin: 12px 0 0 22px;
    position: relative;
    .receive {
      display: inline-block;
      position: absolute;
      bottom: -5px;
      line-height: 1;
      right: 20px;
      color: #2587ff;
      padding-bottom: 4px;
      cursor: pointer;
      border-bottom: 1px solid transparent;
      &:hover {
        border-bottom: 1px solid #2587ff;
      }
    }
    .gray-color {
      color: #c5c5c5;
    }
    img {
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
  }
  .red-border {
    border-color: red;
  }
  .address-box {
    .head {
      background: #f4f7ff;
      color: #333;
    }
    .blue {
      background: #2587ff;
      color: #fff;
    }
  }
  .invioce-box {
    .head {
      background: #f4f7ff;
      color: #333;
    }
    .blue {
      background: #2587ff;
      color: #fff;
    }
  }
  .approve-box {
    .head {
      background: #f4f7ff;
      color: #333;
    }
    .ifSwitch {
      background: #f5f5f5;
    }
    .blue {
      background: #2587ff;
      color: #fff;
    }
  }

  .head {
    height: 40px;
    //   background: #EA9200;
    display: flex;
    font-size: 14px;
    color: #fff;
    justify-content: space-between;
    img {
      width: 20px;
      height: 20px;
      margin: 0 10px 0 20px;
    }
    span {
      @include flex(center, center, row);
    }
    .edit-btn {
      width: 80px;
      height: 40px;
      border-left: 1px solid #fff;
      &:hover {
        background-color: #126edf;
      }
    }
  }
  //   }
}
.dialog-center {
  margin-right: 20px;
}
::v-deep .el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .e-title {
    display: flex;
    justify-content: space-between;
    .icon {
      cursor: pointer;
      .el-icon-close:hover {
        -webkit-appearance: none;
        color: #2587ff;
      }
    }
    .title-name {
      color: #333;
      font-size: 14px;
      display: flex;
      align-items: center;
      img {
        margin-right: 10px;
        width: 18px;
        height: 20px;
      }
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
.e-content {
  ul {
    .address-item {
      border: 1px solid #d9d9d9;
      border-bottom: none;
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #0064c8;
      cursor: pointer;
      .item-r {
        border-bottom: 1px solid transparent;

        &:hover {
          border-bottom: 1px solid #0064c8;
        }
      }
      .line {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .margin-l10 {
        margin-left: 10px;
      }
      &:last-child {
        border-bottom: 1px solid #d9d9d9;
      }
      .right-icon {
        width: 16px;
        height: 16px;
        margin: 0 12px 0 16px;
      }
      .item-txt {
        color: #333;
        font-size: 14px;
      }
      .with-600 {
        width: 600px;
      }
      .item-l {
        font-size: 0;
        p {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 14px;
          line-height: 1;
          &:first-child {
            margin-bottom: 12px;
          }
          ::v-deep .el-radio {
            margin-right: 10px;
          }
        }
        .no-show {
          ::v-deep .el-radio__label {
            display: none;
          }
        }
      }
    }
  }
  .default-icon {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    background: #2587ff;
    color: #fff;
    text-align: center;
    font-size: 12px;
    border-radius: 4px;
    padding: 0 4px;
    margin-right: 4px;
  }
  .margin-l44 {
    margin-left: 25px;
  }
  .is-choose {
    border-bottom: 1px solid #0064c8;
  }
  .process-wrap {
    display: flex;
    margin: 40px 25px;
    text-align: center;
  }
  .process-item {
    .top {
      font-size: 0;
      display: flex;
      // justify-content: center;
      align-items: center;
      .num-circle {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        background: #2587ff;
        font-size: 14px;
        color: #fff;
      }
      .line {
        display: inline-block;
        width: 50px;
        height: 4px;
        background: #2587ff;
      }
    }
    .bottom {
      width: 125px;
      height: 134px;
      overflow-y: auto;
      margin-top: 12px;
      ul {
        li {
          line-height: 1;
          color: #666;
          font-size: 14px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .invoice-list {
    margin: 20px;
    ul {
      border: 1px solid #d9d9d9;
      li {
        padding: 0 20px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 44px;
        border-bottom: 1px solid #d9d9d9;
        &:last-child {
          border-bottom: none;
        }
        .pointer {
          color: #0064c8;
          cursor: pointer;
        }

        .left {
          display: flex;
          align-items: center;
          .invoice-general {
            width: 100px;
            height: 20px;
            background-color: #e8efff;
            color: #2587ff;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            margin-left: 4px;
          }
          .invoice-special {
            width: 100px;
            height: 20px;
            background: rgba(234, 146, 0, 0.1);
            color: #ea9200;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            margin-left: 4px;
          }
          .companyName {
            margin-left: 4px;
            width: 337px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          ::v-deep .el-radio__label {
            display: none;
          }
        }

        .right {
          .edit {
            margin-right: 20px;
            color: #2587ff;
            cursor: pointer;
            border-bottom: 1px solid transparent;
            &:hover {
              border-bottom: 1px solid #2587ff;
            }
          }
          .delete {
            color: #f0250f;
            cursor: pointer;
            border-bottom: 1px solid transparent;
            &:hover {
              border-bottom: 1px solid #f0250f;
            }
          }
        }
      }
    }
  }
}
/* 向右的箭头 */

.arrow-right {
  display: inline-block;
  font-size: 0;
  line-height: 0;
  border-width: 2px;
  border-color: #2587ff;
  border-right-width: 0;
  border-style: dashed;
  border-left-style: solid;
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.arrow-right-white {
  display: inline-block;
  font-size: 0;
  line-height: 0;
  border-width: 2px;
  border-color: #fff;
  border-right-width: 0;
  border-style: dashed;
  border-left-style: solid;
  /* margin-right: 7px; */
  border-top-color: transparent;
  border-bottom-color: transparent;
  position: absolute;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  position: relative;
}
.e-close {
  border: 1px solid #2587ff;
  padding: 0 24px;
  margin-right: 30px;
  &:hover {
    background-color: #126edf;
    color: #fff;
  }
}
.e-confirm {
  padding: 0 12px;
  background: #2587ff;
  color: #fff;
  &:hover {
    background-color: #126edf;
  }
}
</style>
